import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './AddMaterial.css';

function AddMaterial() {

    const [materialsList, setMaterialsList] = useState([]);

    const [materialname, setMaterialName] = useState('');
    const [quantity, setQuantity] = useState('');
    const [instock, setInStock] = useState('');
    const [inhouse, setInHouse] = useState('');

    // ================= FETCH MATERIAL NAMES =================
    useEffect(() => {
        const fetchMaterialNames = async () => {
            try {
                const res = await axios.get(
                    'https://ikaze-thouse-backend.vercel.app/api/MaterialNames'
                );
                setMaterialsList(res.data);
            } catch (err) {
                console.log(err);
            }
        };

        fetchMaterialNames();
    }, []);

    // ================= SAVE MATERIAL =================
    const saveMaterial = async (e) => {
        e.preventDefault();

        try {
            await axios.post(
                'https://ikaze-thouse-backend.vercel.app/api/v1/materials/create',
                {
                    materialname,
                    quantity,
                    instock,
                    inhouse
                }
            );

            alert('Material Added Successfully');

            setMaterialName('');
            setQuantity('');
            setInStock('');
            setInHouse('');

        } catch (error) {
            console.log(error);
            alert('Failed to Add Material');
        }
    };

    return (
        <div className="material-page">

            <div className="material-card">

                <div className="top-section">
                    <h1>Add New Material</h1>
                    <p>Fill in all material details below</p>
                </div>

                <form onSubmit={saveMaterial} className="material-form">

                    {/* MATERIAL NAME DROPDOWN (UPDATED) */}
                    <div className="form-group">
                        <label>Material Name</label>

                        <select
                            value={materialname}
                            onChange={(e) => setMaterialName(e.target.value)}
                            required
                        >
                            <option value="">-- Select Material --</option>

                            {materialsList.map((m) => (
                                <option key={m.m_id} value={m.material_name}>
                                    {m.material_name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="form-group">
                        <label>Quantity</label>

                        <input
                            type="number"
                            placeholder="Enter Quantity"
                            value={quantity}
                            onChange={(e) => setQuantity(e.target.value)}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label>In Stock</label>

                        <input
                            type="number"
                            placeholder="Available Stock"
                            value={instock}
                            onChange={(e) => setInStock(e.target.value)}
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label>In House</label>

                        <input
                            type="number"
                            placeholder="Used In House"
                            value={inhouse}
                            onChange={(e) => setInHouse(e.target.value)}
                            required
                        />
                    </div>

                    <button type="submit" className="save-btn">
                        Save Material
                    </button>

                </form>

            </div>

        </div>
    );
}

export default AddMaterial;